import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Box, Button, Fab, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material'


//import KeyAreaNavBar from "./partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";



const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const HTMLBlock = (props) => {
    const {component} = props
    //const { component } = {Title:"Some custom Text",Description:"Some sort of decently long description. Communicate with your audience.", Button:{Text:"Button Name",URL:"https://www.google.com"}} //props
    //const { settings, PrintView } = props.otherprops
    const { settings, PrintView } = props

    
    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="stretch" sx={{ padding: '10px' }} mt={2}>
            <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={1} sx={{ padding: '24px', height: '100%' }}>
                    <Stack direction="column" gap={2}>
                        {/* {component && component.Title && component.Title !="" && (<Typography variant="h5">{component.Title}</Typography>)} */}
                        {component && component.Content && component.Content !="" && (<Typography dangerouslySetInnerHTML={{ __html: component.Content }} />)}
                        {/*{component && component.Button && component.Button.Text && component.Button.Text !="" && (<Link style={{ textDecoration: "none", color: "inherit" }} to={component.Button.URL}><Button variant="contained">{component.Button.Text}</Button></Link>)} */}
                    </Stack>
                </Paper>
            </motion.div>
        </Grid>
    )

}
export default HTMLBlock